

export const BASE_URL = 'https://oxfordstudycenter.online';
